import { RadioGroup } from '@gx-design/radio';
import { trans } from '@pepita-i18n/babelfish';
import {
    GxFkAddonInput,
    GxFkCheckbox,
    GxFkInput,
    GxFkRadio,
} from 'gtx-react/components/gx-formik';
import { FC } from 'react';
import gtxConstants from '@getrix/common/js/gtx-constants';
import { AutocompleteCity } from 'gtx-react/components/AutocompleteCity/AutocompleteCity';
import { REGISTER_FORM_KEYS, RegisterFormValues } from '../types';
import { Form, useField, useFormikContext } from 'formik';
import { Button } from '@gx-design/button';
import { useFormikValidateFieldOnChangeIfError } from 'gtx-react/hooks/useFormikValidateFieldOnChangeIfError';
import { Alert } from '@gx-design/alert';
import { GxPhoneInput } from 'gtx-react/components/GxPhoneInput';

type AuthRegisterFormProps = {
    errorBox: string | null;
};

export const AuthRegisterForm: FC<AuthRegisterFormProps> = ({ errorBox }) => {
    const [telProps, telMeta] = useField(REGISTER_FORM_KEYS.TELEFONO);
    const [prefixProps] = useField(REGISTER_FORM_KEYS.PREFISSO);
    const { setFieldValue, isSubmitting } =
        useFormikContext<RegisterFormValues>();

    useFormikValidateFieldOnChangeIfError(REGISTER_FORM_KEYS.TELEFONO);

    return (
        <div className="login-content__height">
            <Form className="form-account form-account--register" noValidate>
                <h1 className="gx-title-1">
                    {trans('label.register_at2', {
                        APP_NAME: gtxConstants('APP_NAME'),
                    })}
                </h1>
                <p
                    dangerouslySetInnerHTML={{
                        __html: trans('register.form.text', {
                            TEL_SERVIZIO_CLIENTI:
                                window.gtxConstants.TEL_SERVIZIO_CLIENTI,
                        }),
                    }}
                ></p>

                {errorBox !== null && (
                    <Alert style="error" withMarginBottom>
                        {' '}
                        {errorBox}{' '}
                    </Alert>
                )}

                <div className="scegli-tipologia clearfix">
                    <RadioGroup label="">
                        <GxFkRadio
                            label={trans('label.estate_agency')}
                            name={REGISTER_FORM_KEYS.TIPOIMPRESA}
                            value="0"
                        />
                        <GxFkRadio
                            label={trans('label.building_company')}
                            name={REGISTER_FORM_KEYS.TIPOIMPRESA}
                            value="1"
                        />
                    </RadioGroup>
                </div>

                <GxFkInput
                    type="text"
                    name={REGISTER_FORM_KEYS.NOME}
                    label={trans('label.name')}
                    required
                />
                <GxFkInput
                    type="text"
                    name={REGISTER_FORM_KEYS.COGNOME}
                    label={trans('label.surname')}
                    required
                />
                <GxFkInput
                    type="text"
                    name={REGISTER_FORM_KEYS.NOMESOCIETA}
                    label={trans('label.company_name')}
                    required
                />
                {gtxConstants('AGENCY_REGISTRATION_VAT_FIELD') ? (
                    <GxFkInput
                        type="text"
                        name={REGISTER_FORM_KEYS.PIVA}
                        label={trans('label.vat')}
                        required
                    />
                ) : null}
                <GxFkAddonInput
                    addon={{
                        position: 'left',
                        type: 'icon',
                        value: 'mail',
                    }}
                    required
                    label={trans('label.mail')}
                    name={REGISTER_FORM_KEYS.EMAIL}
                    placeholder={trans('label.example_user_mail')}
                />
                <AutocompleteCity
                    name={REGISTER_FORM_KEYS.ID_COMUNE}
                    placeholder=" "
                />

                <GxPhoneInput
                    {...telProps}
                    error={telMeta.error}
                    label={''}
                    name={REGISTER_FORM_KEYS.TELEFONO}
                    isLabelVisible={false}
                    prefixName={REGISTER_FORM_KEYS.PREFISSO}
                    prefixValue={prefixProps.value}
                    onPrefixChange={(val) => {
                        setFieldValue(REGISTER_FORM_KEYS.PREFISSO, val);
                    }}
                />
                <div className="gx-input-wrapper">
                    <GxFkCheckbox
                        name={REGISTER_FORM_KEYS.PRIVACY}
                        label={
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: trans('register.form.privacy', {
                                        baseUrl:
                                            window.globalVars
                                                .IMMOBILIARE_BASEURL,
                                    }),
                                }}
                            />
                        }
                    />
                </div>
                <Button
                    disabled={isSubmitting}
                    size="fullWidth"
                    type="submit"
                    variant="accent"
                >
                    {trans('btn.label.sign_in')}
                </Button>
            </Form>
        </div>
    );
};
